import { NgIf } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { BadgeComponent } from '@domgen/dgx-fe-components/badge';
import { ButtonComponent } from '@domgen/dgx-fe-components/button';
import { IconComponent } from '@domgen/dgx-fe-components/icon';
import { PanelComponent } from '@domgen/dgx-fe-components/panel';
import { RegistrationPromotionPillComponent } from '@us-registration/ui-components';
import { PaymentFrequency } from '@us-registration/util-models';

@Component({
  selector: 'us-registration-protection-details-purchase-price-option-wib',
  templateUrl: './protection-details-purchase-price-option.component.html',
  styleUrls: ['./protection-details-purchase-price-option.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    BadgeComponent,
    ButtonComponent,
    IconComponent,
    NgIf,
    PanelComponent,
    RegistrationPromotionPillComponent,
  ],
})
export class ProtectionDetailsPurchasePriceOptionComponent implements OnInit {
  @Input() badgeText?: string;
  @Input() buttonLoading = false;
  @Input() buttonText?: string;
  @Input() disclaimer?: string;
  @Input() discountedPrice?: string;
  @Input() newMessage?: string;
  @Input() originalPrice?: string;
  @Input() paymentFrequency?: string;
  @Input() hasDiscountPrice = false;
  @Input() showIcon = false;
  @Input() subscription?: string;
  @Input() subtitle?: string;
  @Output() buttonClicked = new EventEmitter<boolean>();

  isPrepayPaymentOption = false;

  ngOnInit(): void {
    this.isPrepayPaymentOption =
      this.paymentFrequency === PaymentFrequency.Annual;
  }

  onButtonClick(): void {
    this.buttonClicked.emit(this.isPrepayPaymentOption);
  }
}
